import { render, staticRenderFns } from "./sandbox-applicable-promotions.vue?vue&type=template&id=3ddde7e7&scoped=true&"
import script from "./sandbox-applicable-promotions.vue?vue&type=script&lang=tsx&"
export * from "./sandbox-applicable-promotions.vue?vue&type=script&lang=tsx&"
import style0 from "./sandbox-applicable-promotions.vue?vue&type=style&index=0&id=3ddde7e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddde7e7",
  null
  
)

export default component.exports